module.exports = __webpack_public_path__ + "img/mi-speech-chat-bubble-outline.787dccb3.svg";